import { TextTip } from '@@/Tip/TextTip';
import { Datatable } from '@@/datatables';
import { useTableStateWithStorage } from '@@/datatables/useTableState';

import { AccessViewerPolicyModel } from './model';
import { columns } from './columns';

export function EffectiveAccessViewerDatatable({
  dataset,
  emptyMessage = 'The selected user does not have access to any environments.',
  description = 'Effective role for each environment will be displayed for the selected user.',
  noWidget = true,
}: {
  dataset?: Array<AccessViewerPolicyModel>;
  emptyMessage?: string;
  description?: string;
  noWidget?: boolean;
}) {
  const tableState = useTableStateWithStorage('access-viewer', 'Environment');

  if (dataset?.length === 0) {
    return <TextTip color="blue">{emptyMessage}</TextTip>;
  }

  return (
    <Datatable
      dataset={dataset || []}
      columns={columns}
      settingsManager={tableState}
      noWidget={noWidget}
      title="Access"
      description={<TextTip color="blue">{description}</TextTip>}
      disableSelect
      data-cy="effective-access-viewer-datatable"
    />
  );
}
